import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import withSessionContext, { SessionContext } from 'hocs/withSessionContext'
import Table from 'components/table/Table'
import Tree from 'components/tree/Tree'

import styles from './results.scss'

interface IProps {
  className?: string
  width: number
  height: number
}

class Results extends React.PureComponent<IProps> {
  context!: SessionContext
  table: React.RefObject<any> = React.createRef()
  tree: React.RefObject<any> = React.createRef()

  public scrollIntoView() {
    this.table.current.scrollIntoView()
  }

  public focus() {
    const { session } = this.context
    if (session!.script.viewMode === 'table') {
      this.table.current?.focus()
    }

    if (session!.script.viewMode === 'tree') {
      this.tree.current?.focus()
    }
  }

  public refresh() {
    const { session } = this.context
    if (session!.script.viewMode === 'table') {
      this.table.current?.refresh()
    }

    if (session!.script.viewMode === 'tree') {
      this.tree.current?.refresh()
    }
  }

  public selectRows(rowIds: string[]) {
    const { session } = this.context
    if (session!.script.viewMode === 'table') {
      this.table.current?.selectRows(rowIds)
    }
  }

  public deleteSelectedRows() {
    const { session } = this.context
    if (session!.script.viewMode === 'table') {
      this.table.current?.deleteSelectedRows()
    }
  }

  render() {
    const { sessionId, session } = this.context
    const { className, width, height } = this.props

    return (
      <div className={cn(styles.container, className)} data-cy="results">
        {session!.script.viewMode === 'tree' && (
          <Tree
            ref={this.tree}
            key={sessionId}
            width={width}
            height={height}
            recordIds={session!.script.recordIds}
          />
        )}
        {session!.script.viewMode === 'table' && (
          <Table ref={this.table} width={width} height={height} />
        )}
      </div>
    )
  }
}

export default observer(withSessionContext(Results))
